import { Pipe, PipeTransform } from '@angular/core';
import { Schema } from '@app/core/_models/schema';

@Pipe({
  name: 'propertyHasNumericValues',
})

export class PropertyHasNumericValuesPipe implements PipeTransform {
  public transform(properties: Schema, controlName: string): boolean {
    return properties.hasNumericValues(controlName);
  }
}
